import { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./components/Auth/loginPage/loginPage";
import RegisterPage from "./components/Auth/registerPage/registerPage";
import ProtectedRoute from "./components/Auth/ProtectedRoute/protectedRoute";
import DashboardLayout from "./components/Layout/DashboardLayout";
import HomePage from "./components/Home/HomePage";
import DashboardPage from "./components/Dashboard/dashboardPage";
import { pages } from "./routes/pages";
import { AuthProvider } from "./contexts/AuthContext";

import { t } from "./i18n";
const {
  daily: DailyPage,
  salaries: SalaryReportPage,
  deductions: DeductionSection,
  purchases: PurchasesSection,
  materials: MaterialSection,
  reports: EmployeeReportsPage,
  reportProfile: EmployeeReportProfile,
  workTypes: WorkTypesPage,
  monthly: MonthlyReportPage,
  maintenance: MaintenancePage,
  itemHistory: ItemHistoryPage,
  publicItem: PublicItemPage,
  food: FoodPage,
  audit: AuditLogPage,
} = pages;

const PageFallback = () => (
  <div role="status" className="flex min-h-screen items-center justify-center text-slate-500">
    {t("جاري التحميل...")}
  </div>
);

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Suspense fallback={<PageFallback />}>
          <Routes>
            {/* Redirect "/" to "/login" */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} /> {/* Register Route */}
            {/* Scanned QR label of a maintenance item: open to anyone, shows no costs */}
            <Route path="/i/:token" element={<PublicItemPage />} />
            {/* Signed-in pages share one layout (brand bar + navigation) */}
            <Route
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/home" element={<HomePage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/daily" element={<DailyPage />} />
              <Route path="/salaries" element={<SalaryReportPage />} />
              <Route path="/Deduction-section" element={<DeductionSection />} />
              <Route path="/purchases" element={<PurchasesSection />} />
              <Route path="/material" element={<MaterialSection />} />
              <Route path="/reports" element={<EmployeeReportsPage />} />
              <Route path="/work-types" element={<WorkTypesPage />} />
              <Route path="/monthly" element={<MonthlyReportPage />} />
              <Route path="/maintenance" element={<MaintenancePage />} />
              <Route path="/maintenance/items/:assetId" element={<ItemHistoryPage />} />
              <Route path="/food" element={<FoodPage />} />
              <Route path="/audit" element={<AuditLogPage />} />
              <Route path="/reports/:employeeId" element={<EmployeeReportProfile />} />
            </Route>
          </Routes>
        </Suspense>
      </AuthProvider>
    </Router>
  );
};

export default App;
